import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Chip from '../../chip';
import { Icon } from '@iconify/react';
import RevertWorkerModal from '../../revert-worker-modal';

type Props = {
  first_name: string;
  last_name:string;
  role:string;
  status:string;
  workerId?: string;
  teamId?: string;
  onWorkerOut?: () => void;
  onRevert?: () => void;
}

const WorkerCard: React.FC<Props> = ({ last_name, status, first_name, onWorkerOut, onRevert, workerId, teamId }) => {
  const navigate = useNavigate()
  const [showRevertModal, setShowRevertModal] = useState(false);
  
  //console.log(`WorkerCard Debug - Name: ${first_name} ${last_name}, Status: "${status}", Type: ${typeof status}`);
  //console.log(`Should show edit button: ${status === 'Out' || status === 'Assigned'}`);
  
  const handlePencilClick = () => {
    if (status === 'Out') {
      setShowRevertModal(true);
    } else if (status === 'Assigned') {
      // Edit existing assignments
      if (workerId && teamId) {
        navigate(`/team/${teamId}/worker/${workerId}/assign?name=${encodeURIComponent(`${first_name} ${last_name}`)}&edit=true`)
      }
    }
  };

  const handleRevert = () => {
    if (onRevert) {
      onRevert();
      setShowRevertModal(false);
    }
  };

  const handleAssignClick = () => {
    if (workerId && teamId) {
      navigate(`/team/${teamId}/worker/${workerId}/assign?name=${encodeURIComponent(`${first_name} ${last_name}`)}`)
    }
  };

  return (
    <>
      <div className='min-h-20 border gap-2 flex border-gray-200 p-3 items-center bg-white rounded-lg w-full shadow-sm'>
        <div className='w-10 h-10 mb-2 font-medium flex items-center justify-center bg-gray-200 rounded-lg'>
          {`${first_name?.[0]}${last_name?.[0]}`}
        </div>
        <div className='flex-1'>
          <div className='flex flex-col gap-1 justify-between'>
            <h1 className='text-sm font-medium'> {first_name} {last_name}</h1>
            <div>
              <Chip 
                label={status} 
                variant={status === 'Assigned' ? 'success' : status==='Out' ? 'error': 'default'} 
              />
            </div>
          </div> 
        </div>
        <div className='flex items-center gap-1'>
          {/* Debug: status="${status}", condition=${status === 'Out' || status === 'Assigned'} */}
          {status === 'Out' || status === 'Assigned' ? (
            <button
              onClick={handlePencilClick}
              className='p-3 text-xs font-medium text-blue-700 bg-blue-200 hover:bg-blue-100 rounded-md transition-colors flex items-center gap-1 cursor-pointer'
              title={status === 'Out' ? 'Revert worker' : 'Edit assignments'}
            >
              <Icon icon="lucide:user-round-pen" width={24} />
            </button>
          ) : (
            <>
              {onWorkerOut && (
                <button
                  onClick={onWorkerOut}
                  className='px-3 py-4 text-xs font-medium text-red-700 bg-red-200 hover:bg-red-200 rounded-md transition-colors'
                >
                  Out
                </button>
              )}
              <button
                onClick={handleAssignClick}
                className='px-3 py-4 text-xs font-medium text-white bg-blue-700 hover:bg-blue-700 rounded-md transition-colors'
              >
                Assign
              </button>
            </>
          )}
        </div>
      </div>
      <RevertWorkerModal 
        open={showRevertModal}
        workerName={`${first_name} ${last_name}`}
        onRevert={handleRevert}
        onCancel={() => setShowRevertModal(false)}
      />
    </>
  )
}
export default WorkerCard
